import { useState, useEffect } from 'react';
import { Modal, Form, Spinner } from 'react-bootstrap';
import LoadingOverlay from 'react-loading-overlay';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import moment from 'moment';

// Custom Component
import { PrimaryButton } from '../Button';
import PlayerForm from '../Form/PlayerForm';
import SuccessAlert from '../Alert/SuccessAlert'
import ErrorAlert from '../Alert/ErrorAlert'

// API Service
import { editOrganizerPlayerService } from '../../service/tournament.service';
import { getOrganizerTShirtService } from '../../service/tshirt.service';

// Redux-Functions
import { selectUser } from '../../redux/userSlice';

const EditPlayerModal = (props) => {
    const user = useSelector(selectUser);

    const [tShirtList, setTShirtList] = useState([]);
    const [loading, setLoading] = useState(false);
    LoadingOverlay.propTypes = undefined

    const { register, control, setValue, reset, handleSubmit, formState: { errors } } = useForm({
        mode: "all"
    });

    // for setting default values
    useEffect(() => {
        if (props?.selectedData) {
            let defaultValues = {};
            defaultValues.player_name = props?.selectedData?.player_name
            defaultValues.club_name = props?.selectedData?.club_name
            defaultValues.player_email = props?.selectedData?.player_email
            defaultValues.player_contact = props?.selectedData?.player_contact
            defaultValues.player_gender = props?.selectedData?.player_gender
            defaultValues.player_dob = new Date(props?.selectedData?.player_dob)
            defaultValues.player_idcard = props?.selectedData?.player_idcard
            defaultValues.nationality = props?.selectedData?.nationality
            if (props?.selectedData?.dupr_rating) {
                defaultValues.dupr_rating = props?.selectedData?.dupr_rating
            }
            defaultValues.proffesional_player = props?.selectedData?.proffesional_player
            if (props?.selectedData?.tshirt_details) {
                defaultValues.tshirt_id = {
                    value: props?.selectedData?.tshirt_details?.tshirt?.id,
                    label: props?.selectedData?.tshirt_details?.tshirt?.tshirt_name
                }
                defaultValues.tshirt_size_id = {
                    value: props?.selectedData?.tshirt_details?.size?.id,
                    label: props?.selectedData?.tshirt_details?.size?.size
                }
            }
            reset({ ...defaultValues })
        } else {
            reset()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    /**
        * @function fetchOrganizerTShirt
        * @params
        * @description fetch the single tournament details for organizer
    */
    const fetchOrganizerTShirt = async () => {
        try {
            const result = await getOrganizerTShirtService({
                id: props?.tournament?.id
            });
            if (result?.data?.status) {
                setTShirtList(result?.data?.data)
            } else {
                ErrorAlert(result?.response?.data?.message)
            }
        } catch (error) {
            ErrorAlert(error)
        }
    }

    useEffect(() => {
        if (props?.tournament?.id && user?.type === 'organizer') {
            fetchOrganizerTShirt()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props, user])

    /**
        * @function onSubmit
        * @params formdata
        * @description used to edit player details from organizer
    */
    const onSubmit = async (formdata) => {
        const data = {
            player_name: formdata?.player_name,
            club_name: formdata?.club_name,
            player_email: formdata?.player_email,
            player_contact: formdata?.player_contact,
            player_gender: formdata?.player_gender,
            player_dob: moment(formdata?.player_dob).format("YYYY-MM-DD"),
            player_idcard: formdata?.player_idcard,
            nationality: formdata?.nationality,
            ...(props?.tournament?.sports_type === "PICKLEBALL" && {
                dupr_rating: formdata?.dupr_rating
            }),
            proffesional_player: formdata?.proffesional_player ? 1 : 0,
        };

        if (formdata?.tshirt_id?.value) {
            data.tshirt_details = {
                tshirt_id: formdata?.tshirt_id?.value,
                tshirt_size_id: formdata?.tshirt_size_id?.value
            };
        }
        try {
            setLoading(true)
            const result = await editOrganizerPlayerService({
                id: props?.selectedData?.id,
                data
            });
            if (result?.data?.status) {
                SuccessAlert(result?.data?.message)
                props?.fetchOrganizerPlayerList(props?.currentPage + 1)
                reset()
                props.handleClose()
            } else {
                ErrorAlert(result?.response?.data?.message)
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
            ErrorAlert(error)
        }
    }

    return <Modal show={props.show} onHide={props.handleClose} centered size="lg">
        <LoadingOverlay
            active={loading}
            spinner={<Spinner animation="border" />}
        >
            <Modal.Header className='fs-24 fw-600 border-0' closeButton>
                Edit Player
            </Modal.Header>
            <Modal.Body className='d-flex flex-column pt-0 align-items-center'>
                <div className='w-100'>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <PlayerForm
                            tournament={props?.tournament}
                            tShirtList={tShirtList}
                            {...{ control, register, setValue, errors }}
                        />
                        <div className='d-flex justify-content-end align-items-end mt-4'>
                            <div>
                                <PrimaryButton className='fs-14 fw-500 px-5' disabled={loading} loading={loading} type="submit">Edit Player</PrimaryButton>
                            </div>
                        </div>
                    </Form>
                </div>
            </Modal.Body>
        </LoadingOverlay>
    </Modal>
};

export default EditPlayerModal;